export class Headers {
  constructor(routeIn, storeIn, idMaker) {
    this.storeIn = storeIn;
    this.routeIn = routeIn;
    this.idMaker = idMaker;
  }

  base() {
    return {
      Authorization: `Bearer ${this.token()}`,
      'x-ct-trace-id': this.idMaker.generateTraceId(),
      'x-ct-request-id': this.idMaker.generateRequestId()
    };
  }

  token() {
    const currentUser = this.storeIn.state?.currentUser;
    const { user, token } = { ...currentUser };
    if (user && token) {
      return token;
    } if (this.routeIn && this.routeIn.query && this.routeIn.query.token) {
      return this.routeIn.query.token;
    }
    return 'undefined';
  }
}
